// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7dadcbbe","732":"118fcb95","977":"61e2d336"}[chunkId] + ".chunk.js";
};